<template>
  <div class="container-fluid">
    <div class="login">
      <div class="card p-sm-5 p-3" style="width: 40rem;">
        <div class="card-body">
          <h5 class="card-title text-center">
            <img style="width: 60%" src="/assets/logo/logo_white.svg" />
          </h5>

          <form action="#" class="mt-5">
            <span class="text-danger" style="font-size: 14px" v-if="error">
              {{ error }}
            </span>
            <div class="text-white">
              <p class="text-uppercase mb-0">Step 2: Select your Community</p>
            </div>

            <div class="form-group mt-2">
              <input
                type="text"
                name="username"
                v-model="register.username"
                class="form-control"
                placeholder="Community name"
                required
              />
            </div>

            <password-update
              v-model="register"
              :passwordReset="false"
              :error="''"
              :isNew="true"
            />

            <div class="text-center">
              <div class="row">
                <div class="col-12 mt-5 d-flex justify-content-around">
                  <router-link class="btn btn-dark mt-4" to="/register">
                    <i class="fa fa-angle-left" style="padding-right: 5px"></i>
                    Back
                  </router-link>
                  <button
                    type="button"
                    @click="submit()"
                    v-if="isValidPassword && isPasswordMatch"
                    class="btn btn-dark mt-4"
                  >
                    <span v-if="loading">Loading...</span>
                    <span v-else>Next</span>
                    <i class="fa fa-angle-right" style="padding-left: 5px"></i>
                  </button>
                  <button v-else class="btn btn-dark mt-4" disabled>
                    Next
                    <i class="fa fa-angle-right" style="padding-left: 5px"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <sideArrows v-bind:arrows="arrows"></sideArrows>
      <bottomDots v-bind:step="step"></bottomDots>
    </div>
  </div>
</template>

<script>
import PasswordUpdate from "../../profile/pages/password-update.vue";
import bottomDots from "./bottomDots";
import sideArrows from "./sideArrows";

export default {
  components: {
    bottomDots,
    sideArrows,
    PasswordUpdate,
  },
  data() {
    return {
      isValidPassword: false,
      isPasswordMatch: false,
      loading: false,
      error: "",
      step: "step2",
      arrows: {
        left: true,
        rightRoute: "#",
        leftRoute: "/register",
        right: true,
      },
    };
  },
  computed: {
    register: {
      get() {
        return this.$store.state.register;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    async submit() {
      if (this.loading) return;

      const {
        firstname,
        lastname,
        email,
        display_name,
        username,
        password,
        repassword,
      } = this.register;

      if (
        !(
          firstname &&
          lastname &&
          email &&
          display_name &&
          username &&
          password &&
          repassword
        )
      ) {
        this.error = "Alle velden zijn verplicht";
        return;
      }

      this.loading = true;

      const payload = {
        ...this.register,
        password_confirmation: this.register.repassword,
      };

      await this.$store
        .dispatch("post", {
          endpoint: "api/register",
          details: payload,
        })
        .then((data) => {
          if (!data.data.status) {
            this.error = data.data.error;
            return;
          }
          this.$router.push("/registration-finish");
        })
        .catch((e) => {
          this.error = e.response.data.message;
        });

      this.loading = false;
    },
  },
};
</script>

<style scoped>
.container-fluid {
  height: 100vh;
  background: transparent linear-gradient(270deg, #73afe3 0%, #cfe4f6 100%) 0%
    0% no-repeat padding-box;
  opacity: 1;
}

.login {
  display: flex;
  height: 100vh;
  align-items: center;
  justify-content: center;
}

.card {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #00000029;
  border-radius: 20px;
  opacity: 1;
}

.form-control {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #00000029 !important;
  border-radius: 4px !important;
  height: calc(1.5em + 0.75rem + 8px) !important;
  font-size: 15px !important;
}

.btn {
  background: #292929 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #00000029 !important;
  border-radius: 4px !important;
  padding-left: 3rem;
  padding-right: 3rem;
  font-size: 18px !important;
}
</style>
